import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class StartPageHero {
  static init(...parameters) {
    return new StartPageHero(...parameters);
  }

  constructor(block) {
    gsap.registerPlugin(ScrollTrigger);

    const bodyStyle = window.getComputedStyle(document.body);
    const bodyBackgroundColor = bodyStyle.getPropertyValue('--color-body-background');

    const topSection = block.querySelectorAll('.top-section');
    const sections = block.querySelectorAll('.section');

    gsap.to(topSection, {
      scrollTrigger: {
        trigger: topSection,
        onEnter: () => {
          document.body.style.setProperty('--color-body-background', bodyBackgroundColor);
        },
        onEnterBack: () => {
          document.body.style.setProperty('--color-body-background', bodyBackgroundColor);
        },
      },
    });

    [...sections].forEach((section) => {
      const images = section.querySelectorAll('.image-wrapper');
      const content = section.querySelector('.section-content');
      const pinWrapper = content.querySelector('.pin-wrapper');

      ScrollTrigger.matchMedia({
        '(max-width: 1023px)': () => {
          gsap.to(images, {
            yPercent: (i) => {
              switch (i) {
                case 0:
                  return 0;
                case 1:
                  return -30;
                default:
                  return -50;
              }
            },
            scrollTrigger: {
              trigger: section,
              invalidateOnRefresh: true,
              scrub: true,
            },
          });

          gsap.to(content, {
            scrollTrigger: {
              trigger: content,
              start: 'top center',
              end: 'bottom center',
              onEnter: () => {
                document.body.style.setProperty('--color-body-background', section.dataset.backgroundColor);
              },
              onEnterBack: () => {
                document.body.style.setProperty('--color-body-background', section.dataset.backgroundColor);
              },
            },
          });
        },

        '(min-width: 1024px)': () => {
          gsap.to(images, {
            yPercent: (i) => {
              switch (i) {
                case 0:
                  return 0;
                case 1:
                  return -50;
                default:
                  return -80;
              }
            },
            scrollTrigger: {
              trigger: section,
              invalidateOnRefresh: true,
              scrub: true,
            },
          });

          gsap.to(pinWrapper, {
            scrollTrigger: {
              pin: true,
              trigger: pinWrapper,
            },
          });

          gsap.to(content, {
            scrollTrigger: {
              trigger: content,
              start: 'top-=20% top',
              end: 'bottom top',
              scrub: true,
              onEnter: () => {
                document.body.style.setProperty('--color-body-background', section.dataset.backgroundColor);
              },
              onEnterBack: () => {
                document.body.style.setProperty('--color-body-background', section.dataset.backgroundColor);
              },
            },
          });
        },
      });
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-start-page-hero', StartPageHero.init);
}
